module.exports = __webpack_public_path__ + "img/yixin-icon.2a023cf5.png";